
import React, { useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from 'react-helmet-async';

function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setSuccess('');
    setError('');
    try {
      // POST to your backend API that sends emails to admin and user
      const response = await fetch('https://sbsedelhi.com/backend/wp-json/custom/v1/contact', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(form)
});
      if (!response.ok) throw new Error('Failed to send message');
      setSuccess('Your message has been sent!');
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      setError('Failed to send message.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Contact | State Board of Secondary Education, Delhi</title>
        <meta name="description" content="Get in touch with the State Board of Secondary Education, Delhi for any queries or support." />
        <meta name="keywords" content="contact, State Board of Secondary Education, Delhi, enquiries, support" />
      </Helmet>
      <Header />
      <div className='container main-contant contact-content'>
        <div className='inner-page-container'>
          <h1 className='page-title'>Contact Us</h1>
          <div className='row' style={{ display: 'flex', flexWrap: 'wrap', gap: '32px' }}>
            <div className='col-md-6' style={{ flex: 1, minWidth: 320, display: 'flex', alignItems: 'center' }}>
              <div style={{ background: '#f8f9fa', borderRadius: 12, boxShadow: '0 2px 12px #eee', padding: 32, width: '100%' }}>
                <h2 style={{ fontSize: 22, marginBottom: 16 }}>Our Address</h2>
                <div style={{ fontSize: 16, lineHeight: 1.7 }}>
                  <span style={{marginRight:8}}>📍</span>Plot No. 290, Front Side, Sant Nagar, East of Kailash<br />
                  <span style={{marginRight:8}}>🏙️</span>New Delhi- 110065<br />
                  <span style={{marginRight:8}}>✉️</span>Email: <a href="mailto:sbsedelhi@gmail.com">sbsedelhi@gmail.com</a><br />
                  <span style={{marginRight:8}}>✉️</span><a href="mailto:contact@sbsedelhi.com">contact@sbsedelhi.com</a>
                </div>
              </div>
            </div>
            <div className='col-md-6' style={{ flex: 1, minWidth: 320 }}>
              <form onSubmit={handleSubmit} style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #eee', padding: 32 }}>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Name*</label>
                  <input name='name' value={form.name} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Email*</label>
                  <input name='email' type='email' value={form.email} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Phone*</label>
                  <input name='phone' type='tel' value={form.phone} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Subject*</label>
                  <input name='subject' value={form.subject} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Message*</label>
                  <textarea name='message' value={form.message} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16, minHeight: 120 }} />
                </div>
                <button type='submit' disabled={loading} style={{ padding: '12px 0', width: '100%', background: '#007bff', color: '#fff', border: 'none', borderRadius: 6, fontSize: 18, fontWeight: 600, cursor: 'pointer' }}>{loading ? 'Sending...' : 'Send Message'}</button>
                {success && <div style={{ color: 'green', marginTop: 16, fontWeight: 500 }}>{success}</div>}
                {error && <div style={{ color: 'red', marginTop: 16, fontWeight: 500 }}>{error}</div>}
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
